<template>
  <v-autocomplete
    v-model="modelValue"
    :items="players"
    item-value="id"
    item-text="last_name"
    :filter="(item, queryText) => {
      return (item.first_name + item.last_name).toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
    }"
    :loading="loading"
    v-bind="$attrs"
  >
    <template v-slot:selection="{ item }">
      <span>{{ item.first_name }} {{ item.last_name }}</span>
    </template>
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title>
          {{ item.last_name }}, {{ item.first_name }}
          <v-chip
            v-if="item.is_archived"
            x-small
            color="grey"
            dark
            class="ml-1"
          >
            {{ $t('player.archived') }}
          </v-chip>
        </v-list-item-title>
        <v-list-item-subtitle>
          <span v-if="item.teams && item.teams.length">{{ item.teams.map(t => t.short_name).join(', ') }}</span>
          <span
            v-if="item.player_positions && item.player_positions.length > 0 && !isIndividualSport"
          >&middot; {{ item.player_positions.map(p => p.short_name).join(', ') }}</span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>
<script>
export default {
  name: 'PlayersAutocomplete',
  props: {
    players: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: undefined
    }
  },
  computed: {
    currentTeam() {
      return this.$store.getters[this.$storeGetters.APP_CURRENT_TEAM]
    },
    isIndividualSport() {
      return this.currentTeam.sport.is_individual
    },
    modelValue: {
      get: function () {
        return this.value
      },
      set: function (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
